import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, input, signal, viewChild, viewChildren } from '@angular/core';
import { MediaType } from 'src/app/models/file';
import { DisplayMedia } from 'src/app/models/image';
import { ModalService } from 'src/app/services/modal.service';
import { SwiperContainer } from 'swiper/element';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { wait } from 'src/app/utils/async';

@Component({
  selector: 'app-media-slider',
  templateUrl: './media-slider.component.html',
  styleUrls: ['./media-slider.component.scss'],
  standalone: true,
  imports: [VideoPlayerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MediaSliderComponent implements AfterViewInit {
  modalService = inject(ModalService, { optional: true });
  swiperContainer = viewChild<ElementRef<SwiperContainer>>('swiper');

  media = input.required<DisplayMedia[]>();
  initialIndex = input<number | undefined>(0);
  type = input.required<MediaType>();
  modalId = input<string>();

  videoPlayers = viewChildren<VideoPlayerComponent>('videoPlayer');
  header = viewChild<ElementRef>('header');
  muted = signal(false);
  toolbarVisible = signal(false);

  constructor() {
    effect(() => {
      const toolbarVisible = this.toolbarVisible();
      this.toggleToolbar(toolbarVisible);
    });
  }

  ngAfterViewInit() {
    const initialIndex = this.initialIndex() ?? 0;
    this.swiperContainer()?.nativeElement.swiper.slideTo(initialIndex);
    this.init();
  }

  private async init() {
    await wait(10);
    this.toggleToolbar(false);
  }

  handleSlideChange(event: Event) {
    this.updateVideoPlayback();
  }

  updateVideoPlayback() {
    if (this.type() !== 'video') return;
    const activeIndex = this.swiperContainer()?.nativeElement.swiper.activeIndex;
    const videoPlayers = this.videoPlayers();
    videoPlayers.forEach((player, index) => {
      if (index === activeIndex) {
        player.play();
      } else {
        player.pause();
      }
    });
  }

  mediaClick(event: Event) {
    event.stopPropagation();
    this.toolbarVisible.set(!this.toolbarVisible());
  }

  toggleToolbar(show: boolean) {
    const ionHeader = this.header()?.nativeElement as HTMLIonHeaderElement;
    if (!ionHeader) return;
    if (show) {
      ionHeader.style.bottom = '0px';
    } else {
      const height = getComputedStyle(ionHeader).height;
      ionHeader.style.bottom = height;
    }
  }

  close() {
    const modalId = this.modalId();
    if (!modalId) return;
    this.toggleToolbar(false); // it looks cleaner when the toolbar is hidden while the modal closes
    this.modalService?.close(modalId);
  }
}
